<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
<!--          <b-card-->
<!--            border-variant="primary"-->
<!--            header="Primary"-->
<!--            header-bg-variant="primary"-->
<!--            header-text-variant="white"-->
<!--          >

-->
          <b-card header-class="redmfu" >
            <div slot="header" v-if="thai_student==1">
              <strong >ข้อมูลส่วนบุคคล</strong>

            </div>
            <div slot="header" v-if="thai_student==0">
              <strong>Personal data </strong>
            </div>
            <b-row>
<!--              :label-cols="2"-->
              <b-col sm="8">
                <b-form-group
                  :label-cols="5"
                  v-if="thai_student ==1 "
                  label="รหัสประจำตัวนักศึกษา"
                >{{ studentCode }}</b-form-group>
                <b-form-group
                  v-if="thai_student ==0 "
                  label="Student ID No."
                  :label-cols="5"
                >{{ studentCode }}</b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group
                  v-if="thai_student ==1"
                  label="ชื่อ-นามสกุล"
                  label-for="basicStatic"
                  :label-cols="4"

                >
                  <b-form-group
                    :label="name"
                    label-for="basicStatic"
                    :label-cols="12"

                  ></b-form-group>
                </b-form-group>

                <b-form-group
                  v-if="thai_student ==0 "
                  label="Name and Surname"
                  label-for="basicStatic"
                  :label-cols="4"

                >
                  <b-form-group
                    :label="name"
                    label-for="basicStatic"
                    :label-cols="12"

                  ></b-form-group>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group
                  label="ระดับ"
                  :label-cols="3"

                  v-if="thai_student ==1 "
                >
                  <b-form-group
                    :label="levelGroupName"
                    label-for="basicStatic"
                    :label-cols="6"

                  ></b-form-group>
                </b-form-group>
                <b-form-group
                  label="Level"
                  :label-cols="3"

                  v-if="thai_student ==0 "
                >
                  <b-form-group
                    :label="levelGroupNameEng"
                    label-for="basicStatic"

                    :label-cols="6"
                  ></b-form-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group
                  v-if="thai_student ==1 "
                  label="สำนักวิชา"
                  :label-cols="4"

                >
                  <b-form-group
                    :label="facultyName"
                    label-for="basicStatic"
                    :label-cols="6"

                  ></b-form-group>
                </b-form-group>

                <b-form-group
                  v-if="thai_student ==0 "
                  label="School"
                  :label-cols="4"

                >
                  <b-form-group
                    :label="facultyNameEng"
                    label-for="basicStatic"
                    :label-cols="4"

                  ></b-form-group>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <div v-if="thai_student ==1 ">
                  <b-form-group label="สาขาวิชา" :label-cols="3" >
                    <b-form-group
                      :label="departmentName"
                      label-for="basicStatic"
                      :label-cols="12"

                    ></b-form-group>
                  </b-form-group>
                </div>
                <div v-if="thai_student ==0 ">
                  <b-form-group label="Programme" :label-cols="3" >
                    <b-form-group
                      :label="departmentNameEng"
                      label-for="basicStatic"
                      :label-cols="12"

                    ></b-form-group>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: { YimoVueEditor },
  name: "CreateBioPart7",
  data() {
    return {
      idtest: {},
      student: {},
      std_id: "",
      selected_military: "",
      selected_ordinate: "",
      selected_work_status: "",
      numEror: 0,
      sex: "",
      name: "",
      thai_student: "",
      studentCode: "",
      prefixName: "",
      studentName: "",
      studentSurname: "",
      studentNameEng: "",
      studentSurnameEng: "",
      prefixNameEng: "",
      levelGroupName: "",
      levelGroupNameEng: "",
      facultyName: "",
      facultyNameEng: "",
      departmentName: "",
      departmentNameEng: "",
      current_erorrtxt: "",
      dangerModal: false,
      items: [],
      actionUpdate: true
    };
  },
  methods: {
    getStudentBio() {
      //"msg": "Missing Authorization Header"
      // console.log("user==", this.$store.state.user);
      this.sex = this.$store.state.user.sex;
      this.thai_student = this.$store.state.user.thaistudent;
      this.studentId = this.$store.state.user.studentid;
      this.std_id = this.$store.state.user.studentid;
      this.studentCode = this.$store.state.user.studentcode;

      this.prefixName = this.$store.state.user.prefixname;
      this.studentName = this.$store.state.user.studentname;
      this.studentSurname = this.$store.state.user.studentsurname;
      if (this.studentSurname == null) {
        this.studentSurname = "";
      }
      this.name =
        this.prefixName +
        "   " +
        this.studentName +
        "   " +
        this.studentSurname;
      this.prefixNameEng = this.$store.state.user.prefixnameeng;
      this.studentNameEng = this.$store.state.user.studentnameeng;
      this.studentSurnameEng = this.$store.state.user.studentsurnameeng;

      this.levelGroupName = this.$store.state.user.levelgroupname;
      this.levelGroupNameEng = this.$store.state.user.levelgroupnameeng;
      this.departmentName = this.$store.state.user.departmentname;
      this.departmentNameEng = this.$store.state.user.departmentnameeng;
      this.facultyName = this.$store.state.user.facltyname;
      this.facultyNameEng = this.$store.state.user.facltynameeng;
      this.levelid = this.$store.state.user.levelid;
    }
  },
  mounted() {},
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/Login_63");
    } else {
      // this.$router.push("/Dashboard");
      this.getStudentBio();
    }

    // console.log("state.user==",this.$store.state.user)
    // console.log("state.user.studentid==",this.$store.state.user.studentid)


  }
};
</script>
<style>
.redmfu{
  background-color: #c93632;
  color: white;
}
</style>
